/* eslint-disable @blumintinc/blumint/extract-global-constants */
import React, { useState } from 'react';
import { SearchResults } from '../search/SearchResults';
import { InputSearch } from './InputSearch';
import { SearchProvider } from 'src/contexts/SearchContext';

export const SearchBar: React.FC = ({}) => {
  const [searchBarOpen, setSearchBarOpen] = useState(false);

  return (
    <SearchProvider>
      {searchBarOpen ? (
        <SearchResults
          onClose={() => {
            return setSearchBarOpen(false);
          }}
        />
      ) : (
        <InputSearch
          onOpen={() => {
            return setSearchBarOpen(true);
          }}
        />
      )}
    </SearchProvider>
  );
};
